export default {
  mockAPI: true
}



// WEBPACK FOOTER //
// ./src/settings.js